// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zai-native-side-chat {
  position: fixed;
  top: 0;
  right: 0;
  width: 580px;
  height: 100%;
  z-index: 99999999990;
  pointer-events: none;
}
.zai-native-side-chat[data-open=true] {
  pointer-events: auto;
}`, "",{"version":3,"sources":["webpack://./src/modules/zai/zai-native-side-chat/zai-native-side-chat.styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;AACF;AACE;EACE,oBAAA;AACJ","sourcesContent":[".zai-native-side-chat {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 580px;\n  height: 100%;\n  z-index: 99999999990;\n  pointer-events: none;\n\n  &[data-open='true'] {\n    pointer-events: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
